// Airlines registry — central index for all transition landing pages.
// Air France is hand-crafted (validated by the user). All other
// airlines are rendered from the AIRLINE_CATALOG via the contentGenerator.

import airFrance from './airFrance';
import { AIRLINE_CATALOG } from './catalog';
import { generateAirlineContent, DEFAULT_AIRLINE_HERO } from './contentGenerator';

// Map slug -> airline object
const handCrafted = { [airFrance.slug]: airFrance };

const generated = AIRLINE_CATALOG.reduce((acc, a) => {
  // Only English is generated. Multi-language pages are hand-crafted on demand.
  const airlineObj = {
    slug: a.slug,
    airline: a.name,
    heroImage: a.heroImage || DEFAULT_AIRLINE_HERO,
    en: generateAirlineContent(a, 'en'),
  };
  acc[a.slug] = airlineObj;
  return acc;
}, {});

export const AIRLINES = { ...handCrafted, ...generated };

// Convenience helper for the router
export const getAirline = (slug) => AIRLINES[slug] || null;

// Resolve { airline, content } for a given slug + lang (default EN).
export const getAirlineContent = (slug, lang) => {
  const airline = getAirline(slug);
  if (!airline) return null;
  if (!lang) return { airline, content: airline.en };
  const langContent = airline[lang];
  if (langContent) return { airline, content: langContent };
  return null;
};
